import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: process.env.REACT_APP_DEFAULT_LANGUAGE,
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/assets/i18n/{{ns}}/{{lng}}.json?v=2.8`
        },
        fallbackLng: 'en',
        debug: false,
        ns: ['translations'],
        defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            wait: true
        }
    })

export default i18n